import { format } from 'date-fns';
import { apiAxios } from '@/lib/apiAxios';
import { DATE_FORMAT_ISO } from '@/constants/date';
const buildResultsParams = ({ from, to, excludeDevices, excludeBrowsers }) => ({
    from: format(from, DATE_FORMAT_ISO),
    to: format(to, DATE_FORMAT_ISO),
    'excludeDevices[]': excludeDevices,
    'excludeBrowsers[]': excludeBrowsers,
});
export const fetchActiveDesignExperiment = (campaignPublicId) => apiAxios
    .get(`/campaigns/${campaignPublicId}/design-experiments/active`, {
    // 204 = no active experiment; treat as null below.
    validateStatus: (status) => status === 200 || status === 204,
})
    .then((response) => (response.status === 204 ? null : response.data));
export const fetchDesignExperiments = (campaignPublicId) => apiAxios
    .get(`/campaigns/${campaignPublicId}/design-experiments`)
    .then((response) => response.data);
export const fetchDesignExperimentResults = ({ campaignPublicId, experimentPublicId, ...filter }) => apiAxios
    .get(`/campaigns/${campaignPublicId}/design-experiments/${experimentPublicId}/results`, { params: buildResultsParams(filter) })
    .then((response) => response.data);
export const startDesignExperiment = ({ campaignPublicId, variants, }) => apiAxios
    .post(`/campaigns/${campaignPublicId}/design-experiments`, { variants })
    .then((response) => response.data);
export const concludeDesignExperiment = ({ campaignPublicId, experimentPublicId, winnerKey, }) => apiAxios
    .patch(`/campaigns/${campaignPublicId}/design-experiments/${experimentPublicId}/conclude`, { winnerKey })
    .then((response) => response.data);
